import { useOfferWhatsCoveredStrings } from "../../utils";
import { WhatsCoveredTitle } from "./whats-covered-title";
import { ItemsWrapper, WhatsCoveredContainer } from "./styles";
import { Items } from "./items";
import { useTranslation } from "react-i18next";

export function WhatsCovered() {
  const { t } = useTranslation("screens", { keyPrefix: "offer.whatsCovered" });

  const whatsCoveredStrings = useOfferWhatsCoveredStrings();
  return (
    <WhatsCoveredContainer>
      <WhatsCoveredTitle />
      <div>
        <ItemsWrapper>
          <Items
            title={whatsCoveredStrings.yourHealth.title}
            popupTitle={t("yourHealth.popup.title")}
            topics={whatsCoveredStrings.yourHealth.topics}
          />
        </ItemsWrapper>
        <ItemsWrapper>
          <Items
            title={whatsCoveredStrings.yourTrip.title}
            popupTitle={t("yourTrip.popup.title")}
            topics={whatsCoveredStrings.yourTrip.topics}
          />
        </ItemsWrapper>
        <ItemsWrapper>
          <Items
            title={whatsCoveredStrings.yourStuff.title}
            popupTitle={t("yourStuff.popup.title")}
            topics={whatsCoveredStrings.yourStuff.topics}
          />
        </ItemsWrapper>
      </div>
    </WhatsCoveredContainer>
  );
}
